import React from "react";
import {Link} from "react-router-dom";
import styles from "./continue-button.module.css";
import clsx from "clsx";

const ContinueButton = ({ text="Continue", link, onClick, enabled = true, buttonStyles }) => {
  return (
    <Link to={link} onClick={onClick} className={clsx(styles.link, !enabled && styles.disabledLink)}>
      <div className={styles.button} style={buttonStyles}>{text}</div>
    </Link>
  );
};

export { ContinueButton };
